import './index.css';
import * as TYPE from './types';
import * as CONST from './constants';
import * as UTIL from './utils';
import * as ANIMATE from './animate';
import * as _ from 'lodash-es';

export default class CRT {
  overlayEl: any;
  xs: any[];
  dots: any[];
  minX: any;
  maxX: any;
  hvrIndex: any;
  wrapperEl: HTMLElement;
  viewEl: any;
  scaleX: number;
  hvrTooltipEls: any;
  gcDiv: any;
  yLines: any[];
  hvrLineEl: any;
  viewSvg: any;
  viewLineGroup: Element;
  viewPaths: any[];
  hvrBoxEl: any;
  xAxisEl: any;
  xLabels: any[];
  minimapEl: any;
  minimapSvg: any;
  minimapPaths: any[];
  minimapWindowEl: any;
  gscaleX: number;
  draggerLeftEl: any;
  draggerRightEl: any;
  legendEl: any;
  legendLabelEls: any[];
  initialized: boolean;
  scaleY: any;
  gscaleY: any;
  minimapSvgGroup: any;
  myReq: any;
  apiData: any;
  formatHours: boolean;
  rawData: any;
  hideSB: () => void;

  constructor(wrapperId: string, data: any, opts?: any) {
    opts = opts || {};

    this.rawData = data;
    this.apiData = UTIL.convertData(data);

    data = UTIL.balanceData(this.apiData);

    let i, label;
    let { xs, dots } = data;

    this.xs = xs;
    this.dots = dots;

    this.minX = this.xs[0]; // 0%
    this.maxX = this.xs[this.xs.length - 1]; // 100%

    this.hideSB = () => {
      // console.log('this.hvrIndex', this.hvrIndex);
      this.overlayEl.style.display = 'none';
      this.hvrIndex = null;
    };

    this.wrapperEl = document.querySelector(wrapperId);
    this.viewEl = document.querySelector(wrapperId.concat(' .crt__view'));

    this.overlayEl = document.querySelector(wrapperId.concat(' .crt__overlay'));
    this.overlayEl.style.display = 'none';
    this.overlayEl.innerHTML = '';

    this.скВИ(
      this,
      this.viewEl,
      (
        e: TYPE.ComboTouchEvent,
        delta: number,
        old: { minX: number; maxX: number },
        drag: any
      ) => {
        let i, touch, x;

        // console.log('drag', drag);

        if (drag) {
          delta = -delta / this.scaleX;
          delta = Math.max(delta, -old.minX);
          delta = Math.min(delta, 100 - old.maxX);
          this.minX = old.minX + delta;
          this.maxX = old.maxX + delta;
          //this.hvrIndex = null;
          for (i = 0; i < this.hvrTooltipEls.length; i++) {
            this.hvrTooltipEls[i].classList.add('animated');
          }
          this.updateView();
          return;
        }

        touch = e;
        x =
          this.minX +
          (touch.pageX -
          this.viewEl.getBoundingClientRect().left - // SO HARD
            window.pageXOffset) /
            this.scaleX;
        this.hvrIndex = 0;
        for (i = 1; i < this.xs.length; i++) {
          if (this.xs[i] < this.minX || this.xs[i] > this.maxX) {
            continue;
          }
          if (Math.abs(this.xs[i] - x) < Math.abs(this.xs[this.hvrIndex] - x)) {
            // whoa
            this.overlayEl.style.display = 'block';
            this.hvrIndex = i;
          }
        }

        for (i = 0; i < this.hvrTooltipEls.length; i++) {
          this.hvrTooltipEls[i].classList.remove('animated');
        }
        this.updateView();
      },
      (e: any, drag: any) => {
        for (let i = 0; i < this.hvrTooltipEls.length; i++) {
          this.hvrTooltipEls[i].classList.toggle('animated', !drag);
        }
        if (!e.touches && !drag) {
          this.hideSB();
          this.updateView();
        }
      }
    );
    document.body.addEventListener(
      CONST.E.start,
      (e: { target: any }) => {
        let el = e.target;
        while (el !== document.body) {
          if (el === this.wrapperEl) {
            return;
          }
          el = el.parentNode;
        }

        this.hideSB();
        this.updateView();
      },
      UTIL.passiveEventlistenerOpts()
    );

    this.gcDiv = document.querySelector(wrapperId.concat(' .crt__gc'));
    this.gcDiv.innerHTML = '';

    this.yLines = [];

    this.hvrLineEl = UTIL.createEl(this.overlayEl, 'hvr-line');

    this.viewSvg = document.querySelector(wrapperId.concat(' .crt__view-svg'));
    this.viewLineGroup = document.querySelector(
      wrapperId.concat(' .crt__view-svg g')
    );

    this.viewPaths = [];

    for (i = 0; i < this.dots.length; i++) {
      this.viewPaths.push(
        UTIL.createPath(this.viewLineGroup, this.xs, this.dots[i], 'path-' + i)
      );
    }

    this.hvrTooltipEls = [];
    for (i = 0; i < this.dots.length; i++) {
      this.hvrTooltipEls.push(
        UTIL.createEl(this.overlayEl, 'hvr-tooltip dots-' + i)
      );
    }
    this.hvrBoxEl = UTIL.createEl(this.overlayEl, 'hvr-box');

    this.xAxisEl = document.querySelector(wrapperId.concat(' .crt__x-axis'));
    this.xAxisEl.innerHTML = '';
    this.xLabels = [];

    this.minimapEl = document.querySelector(wrapperId.concat(' .crt__minimap'));
    this.minimapSvg = document.querySelector(
      wrapperId.concat(' .crt__minimap-svg')
    );
    this.minimapSvgGroup = document.querySelector(
      wrapperId.concat(' .crt__minimap-svg g')
    );

    // this.minimapSvgGroup.innerHTML = ''; // TODO WHY I DID THIS?????????????

    this.minimapPaths = [];

    for (i = 0; i < this.dots.length; i++) {
      this.minimapPaths.push(
        UTIL.createPath(
          this.minimapSvgGroup,
          this.xs,
          this.dots[i],
          'minimap-path-' + i
        )
      );
    }

    this.minimapWindowEl = document.querySelector(
      wrapperId.concat(' .crt__minimap-window')
    );
    this.скВИ(
      this,
      this.minimapWindowEl,
      (e: any, delta: number, old: { minX: number; maxX: number }) => {
        delta = delta / this.gscaleX;
        delta = Math.max(delta, -old.minX);
        delta = Math.min(delta, 100 - old.maxX);

        this.minX = old.minX + delta;
        this.maxX = old.maxX + delta;
        this.hideSB();
        this.updateView();
      },
      false,
      true
    );
    this.draggerLeftEl = document.querySelector(
      wrapperId.concat(' .crt__dragger.left')
    );
    this.скВИ(
      this,
      this.draggerLeftEl,
      (e: any, delta: number, old: { minX: number }) => {
        // strict num
        // if (this.maxX - this.minX < 10) {
        //   console.log('D', this.maxX - this.minX);
        //   this.minX = this.maxX - 10.0000000000000001;

        //   // this.updateView();

        //   // return false;
        // }

        delta = delta / this.gscaleX;
        this.minX = old.minX + delta;
        this.minX = Math.min(this.minX, this.maxX - 7);
        this.minX = Math.max(0, this.minX);
        this.hideSB();

        this.updateView();
      },
      false,
      true
    );
    this.draggerRightEl = document.querySelector(
      wrapperId.concat(' .crt__dragger.right')
    );
    this.скВИ(
      this,
      this.draggerRightEl,
      (e: any, delta: number, old: { maxX: number }) => {
        // strict num
        delta = delta / this.gscaleX;
        this.maxX = Math.max(this.minX + 7, old.maxX + delta);
        this.maxX = Math.min(this.maxX, 100);
        this.hideSB();
        this.updateView();
      },
      false,
      true
    );
    this.скВИ(this, this.minimapSvg, (e: Touch & TouchEvent, delta: number) => {
      let touch = e,
        sz = Math.abs(delta) / this.gscaleX,
        x1 =
          touch.pageX -
          this.minimapSvg.getBoundingClientRect().left - // SO HARD
          window.pageXOffset,
        mid = (x1 - delta / 2) / this.gscaleX;
      mid = mid;
      mid = Math.min(100, mid);
      this.minX = mid - sz / 2;
      this.maxX = Math.min(mid + sz / 2, 100);
      this.hideSB();
      this.updateView();
    });

    this.legendEl = document.querySelector(wrapperId.concat(' .crt__legend'));
    this.legendEl.innerHTML = ''; // TODO generalize

    this.legendLabelEls = [];
    for (i = 0; i < this.dots.length; i++) {
      label = UTIL.createEl(
        this.legendEl,
        'legend-label dots-' + i + ' active'
      );
      label.innerText = this.dots[i].name;
      label.style['background-color'] = this.dots[i].color;

      label.addEventListener(
        CONST.E.start,
        this.onLegendLabelToggle.bind(this, i),
        true
      );

      this.legendLabelEls.push(label);
    }

    this.updateView();

    window.addEventListener('resize', () => this.updateView, true);
    this.initialized = true;
  }

  getDateByPercent(percent) {
    return this.apiData.xs[
      Math.min(
        this.apiData.xs.length - 1,
        Math.round((this.apiData.xs.length * percent) / 100)
      )
    ];
  }

  zoomTo(minX, maxX) {
    const xSteps = [
      this.minX < minX ? 0.5 : -0.5,
      this.maxX > maxX ? 0.5 : -0.5
    ];

    const smoothZoom = setInterval(() => {
      this.injection({
        minX: this.minX + xSteps[0], // 40.5
        maxX: this.maxX - xSteps[1] // 55.5
      });

      if (Math.abs(this.minX - minX) < 1) {
        this.injection({
          minX,
          maxX
        });
        clearInterval(smoothZoom);
      }

      this.updateView();
    }, 24);
  }

  injection(attrs: {}) {
    Object.keys(attrs).forEach((attrName) => {
      this[attrName] = attrs[attrName];
    });

    this.updateView();
  }

  // Event handlers
  onLegendLabelToggle(index: string | number) {
    const newStatus = !this.dots[index].isActive;
    const isAllowed = this.dots
      .map((i, idx) => (index === idx ? newStatus : i.isActive))
      .includes(true);

    if (isAllowed) {
      this.dots[index].isActive = newStatus;
      this.updateView();
    } else {
      ANIMATE.animateCSS(this.legendLabelEls[index], 'bounce', () => {
        this.legendLabelEls[index].classList.remove('bounce');
      });
    }
  }

  // TODO style animations => repaintless
  onYLineTransitionEnd(e: any) {
    //  TYPE.ComboTouchEvent
    for (let i = 0; i < this.yLines.length; i++) {
      if (this.yLines[i].lineEl == e.target) {
        e.target.removeEventListener(
          'transitionend',
          this.onYLineTransitionEnd,
          true
        );
        this.gcDiv.removeChild(this.yLines[i].labelEl);
        this.gcDiv.removeChild(this.yLines[i].lineEl);
        this.yLines.splice(i, 1);
        return;
      }
    }
  }

  onXLabelTransitionEnd(e: any, i: any) {
    for (let i = 0; i < this.xLabels.length; i++) {
      if (this.xLabels[i].el == e.target) {
        e.target.removeEventListener(
          'transitionend',
          this.onXLabelTransitionEnd,
          true
        );
        this.xAxisEl.removeChild(this.xLabels[i].el);
        this.xLabels.splice(i, 1);
      }
    }
  }

  updateView() {
    let W = this.viewEl.offsetWidth, // reflow?
      H = this.viewEl.offsetHeight, // reflow?
      oH = this.minimapEl.offsetHeight, // reflow?
      maxY = 0,
      gmaxY = 0,
      firstX = null,
      i,
      j,
      x,
      y,
      scaleX = W / (this.maxX - this.minX),
      gscaleX = W / 100,
      order,
      scaleY,
      gscaleY,
      dots,
      oldScaleY, // = this.scaleY,
      add,
      line,
      updateLine,
      updateLabel,
      stepX,
      stepY,
      day,
      label,
      left,
      percent,
      highest,
      windowL,
      windowR,
      html;

    // todo for to generator?
    for (i = 0; i < this.dots.length; i++) {
      dots = this.dots[i];
      if (dots.isActive) {
        for (j = 0; j < this.xs.length; j++) {
          if (this.minX <= this.xs[j] && this.xs[j] <= this.maxX) {
            maxY = Math.max(maxY, dots.pts[j]);
            if (firstX === null) {
              firstX = this.xs[j];
            }
          }
          gmaxY = Math.max(gmaxY, dots.pts[j]);
        }
      }
    }

    // TODO math PI log log10
    // oh mane
    order = Math.pow(10, Math.floor(Math.log(maxY) * Math.LOG10E)) / 2; // TODO to CONST
    maxY = Math.ceil(maxY / order) * order;
    stepY = maxY / 5; // TODO const 5 horiz lines
    scaleY = (H - 30) / maxY; // WATAFFAKKK
    gscaleY = (oH - 4) / gmaxY;
    oldScaleY = this.scaleY;

    // Update horizontal grid lines & labels
    add = {};
    for (i = 0; i <= 5; i++) {
      add[stepY * i] = true;
    }

    for (i = 0; i < this.yLines.length; i++) {
      line = this.yLines[i];

      if (add[line.y]) {
        line.lineEl.style.opacity = 1;
        line.labelEl.style.opacity = 1;
        delete add[line.y];
        line.lineEl.removeEventListener(
          'transitionend',
          this.onYLineTransitionEnd,
          true
        );
      } else {
        line.lineEl.style.opacity = 0;
        line.labelEl.style.opacity = 0;
        // console.log('REG');
        // line.lineEl.addEventListener(
        //   'transitionend',
        //   this.onYLineTransitionEnd,
        //   true
        // );
      }
      line.lineEl.style.bottom = line.y * scaleY + 'px';
      line.labelEl.style.bottom = line.y * scaleY + 'px';
    }

    for (y in add) {
      line = {
        y: y,
        lineEl: UTIL.createEl(this.gcDiv, 'y-line'),
        labelEl: UTIL.createEl(this.gcDiv, 'y-label')
      };

      line.labelEl.dataset.percentage = y;

      if (this.scaleY !== undefined) {
        line.lineEl.style.bottom = line.y * oldScaleY + 'px';
        line.labelEl.style.bottom = line.y * oldScaleY + 'px';
      }

      updateLine = function(line: { lineEl: any; y: number; labelEl: any }) {
        line.lineEl.style.opacity = 1;
        line.lineEl.style.bottom = line.y * scaleY + 'px';
        line.labelEl.style.opacity = 1;
        line.labelEl.style.bottom = line.y * scaleY + 'px';

        line.labelEl.innerText = UTIL.formatNumber(
          Math.ceil(
            (parseInt(line.labelEl.dataset.percentage) *
              Math.max(
                ...this.dots.map((i, idx) =>
                  Math.max(...this.apiData.dots[idx].pts)
                )
              )) /
              100
          ) +
            Math.min(
              ...this.dots.map((i, idx) =>
                Math.min(...this.apiData.dots[idx].pts)
              )
            )
        );
      }.bind(this, line);

      if (this.initialized) {
        setTimeout(updateLine, 0);
      } else {
        updateLine();
      }
      this.yLines.push(line);
    }

    // XXXXXXXXXX Update horizontal axis labels XXXXXXXXXXX
    stepX = 1;
    // getDaySize 70 => calc()
    while (stepX * scaleX < 77) {
      stepX *= 2;
    }
    day = Math.floor(firstX / stepX) * stepX;

    add = {};

    // OH MANE
    while ((day - this.minX - stepX) * scaleX < W && day <= 100) {
      if (day >= firstX) {
        add[day] = this.apiData.xs[
          Math.round((this.apiData.xs.length / 100) * parseInt(day))
        ];
      }
      day += stepX;
    }

    const t1: any = Object.values(add)[1];
    const t2: any = Object.values(add)[0];

    this.formatHours = Math.floor((t1 - t2) / CONST.MS.d) === 0;

    // todo for foreach
    // console.log('add', add);
    for (i = 0; i < this.xLabels.length; i++) {
      label = this.xLabels[i];
      if (!label) {
        return;
      }
      if (add[label.x]) {
        label.el.style.opacity = 1;
        delete add[label.x];
        // label.el.removeEventListener(
        //   'transitionend',
        //   this.onXLabelTransitionEnd,
        //   true
        // );
      } else {
        label.el.style.opacity = 0;
        // ANIMATE.animateCSS(label.el, 'zoomOut', () => {
        // this.onXLabelTransitionEnd(label.el, i);
        // label.el.remove();
        // this.xLabels[i] = null;
        // });
        // console.log('REG');
        label.el.addEventListener(
          'transitionend',
          this.onXLabelTransitionEnd.bind(this),
          true
        );
      }

      label.el.style.left = (label.x - this.minX) * scaleX - 35 + 'px';

      label.el.innerText = UTIL.formatDate(
        parseInt(label.el.dataset.timestamp),
        this.formatHours ? 'T' : 'M d'
      );
    }

    for (x in add) {
      label = {
        x: x,
        el: UTIL.createEl(this.xAxisEl, 'x-label')
      };

      // label.el.innerText = UTIL.formatDate(parseFloat(x), false, true);
      // label.el.innerText = add[x];

      // label.el.dataset.offset = x;
      label.el.dataset.timestamp = add[x];

      label.el.style.left = (label.x - this.minX) * scaleX - 35 + 'px';

      updateLabel = function(label: { el: any }) {
        label.el.style.opacity = 1;
        label.el.innerText = UTIL.formatDate(
          parseInt(label.el.dataset.timestamp),
          this.formatHours ? 'T' : 'M d'
        );
      }.bind(this, label);

      if (this.initialized) {
        setTimeout(updateLabel, 0);
      } else {
        updateLabel();
      }
      this.xLabels.push(label);
    }

    ANIMATE.animToMatrix(this.viewLineGroup, [
      scaleX,
      0,
      0,
      1,
      -this.minX * scaleX,
      0
    ]);

    for (i = 0; i < this.minimapPaths.length; i++) {
      ANIMATE.animToMatrix(this.viewPaths[i], [1, 0, 0, scaleY, 0, 0]);
    }
    for (i = 0; i < this.minimapPaths.length; i++) {
      this.viewPaths[i].style.opacity = this.dots[i].isActive ? 1 : 0;
    }

    // Update hvr
    // todo remove extra paddings?
    if (this.hvrIndex === null) {
      // this.hvrLineEl.style.display = 'none';
      for (i = 0; i < this.hvrTooltipEls.length; i++) {
        // this.hvrTooltipEls[i].style.display = 'none';
      }
      // this.hvrBoxEl.style.display = 'none';
    } else {
      left = (this.xs[this.hvrIndex] - this.minX) * scaleX;
      percent = (this.xs[this.hvrIndex] - this.minX) / (this.maxX - this.minX);
      highest = 0;
      // this.hvrLineEl.style.display = 'block'; // SOOOOOOOQAAAAAAAAAAAA
      this.hvrLineEl.style.left = left + 'px';
      for (i = 0; i < this.hvrTooltipEls.length; i++) {
        y = this.dots[i].pts[this.hvrIndex] * scaleY;
        // this.hvrTooltipEls[i].style.display = 'block';
        this.hvrTooltipEls[i].style.opacity = this.dots[i].isActive ? 1 : 0;
        this.hvrTooltipEls[i].style.borderColor = this.dots[i].color;
        this.hvrTooltipEls[i].style.left = left + 'px';
        this.hvrTooltipEls[i].style.bottom = y + 'px';
        if (this.dots[i].isActive) {
          highest = Math.min(
            highest,
            H - y - this.hvrBoxEl.offsetHeight - 15 // SOOOOOOOOOOOQA
          );
        }
      }

      html = [];
      html.push(
        '<div onclick="zoomTo(' +
          this.hvrIndex +
          ')" class="crt__hvr-box-labels">'
      );
      html.push(
        '<span class="crt__hvr-box-labels-date">' +
          UTIL.formatDate(this.apiData.xs[this.hvrIndex], 'D, d M y') +
          '</span>'
      );

      for (i = 0; i < this.dots.length; i++) {
        if (this.dots[i].isActive) {
          html.push(
            '<div class="crt__hvr-box-label" style="color: ',
            this.dots[i].color,
            '">',
            '<span>',
            this.dots[i].name,
            '</span>',
            '<b>',
            Math.ceil(this.apiData.dots[i].pts[this.hvrIndex]),
            '</b>',
            '</div>'
          );
        }
      }
      html.push('</div>');
      this.hvrBoxEl.innerHTML = html.join(''); // TODO wat?

      // this.hvrBoxEl.style.display = 'block';
      this.hvrBoxEl.style.left =
        Math.max(
          Math.min(
            W - this.hvrBoxEl.offsetWidth / 2,
            left - this.hvrBoxEl.offsetWidth * percent
          )
        ) + 'px';
      this.hvrBoxEl.style.top = highest + 'px';
    }

    // Update minimap paths
    for (i = 0; i < this.minimapPaths.length; i++) {
      this.minimapPaths[i].style.opacity = this.dots[i].isActive ? 1 : 0;
      ANIMATE.animToMatrix(this.minimapPaths[i], [
        gscaleX,
        0,
        0,
        gscaleY,
        0,
        0
      ]);
    }

    // Update minimap window
    // TODO outline => shtorki =))))

    windowL = this.minX / 100;
    windowR = this.maxX / 100;

    this.minimapWindowEl.style.left = windowL * 100 + '%';
    this.minimapWindowEl.style.right = 100 - windowR * 100 + '%';

    const shadeLeft: any = document.querySelector('.crt__minimap__shade-left');
    const shadeRight: any = document.querySelector(
      '.crt__minimap__shade-right'
    );

    shadeLeft.style.width = windowL * 100 + '%';
    shadeRight.style.width = 100 - windowR * 100 + '%';

    // Update legend labels
    for (i = 0; i < this.dots.length; i++) {
      this.legendLabelEls[i].classList.toggle('active', this.dots[i].isActive);
    }

    this.scaleX = scaleX;
    this.scaleY = scaleY;
    this.gscaleX = gscaleX;
    this.gscaleY = gscaleY;

    // TODO nan?
    const ovDates = [
      UTIL.formatDate(this.getDateByPercent(this.minX), 'd M y'),
      UTIL.formatDate(this.getDateByPercent(this.maxX), 'd M y')
    ];

    const zoomDates = [
      UTIL.formatDate(this.getDateByPercent(this.minX), 'D M, T'),
      UTIL.formatDate(this.getDateByPercent(this.maxX), 'D M, T')
    ];

    document.querySelector('.crt__toolbar__info').innerHTML =
      ovDates[0] === ovDates[1]
        ? `${zoomDates[0]} - ${zoomDates[1]}`
        : `${ovDates[0]} - ${ovDates[1]}`;
  }

  скВИ(
    chart: {
      minX: any;
      maxX: any;
      wrapperEl: Element;
    },
    el: TYPE.ComboElement, // wat
    handler: any, // TODO arg2 do better types
    endHandler?: any, // func
    attachToWrapper?: boolean
  ) {
    let startX: number, oldMinX: any, oldMaxX: any, drag: boolean;

    // console.log(handler);

    function onDragStart(e: any) {
      // TODO all e
      // console.log('ST', !attachToWrapper, e.target === el);
      if (!attachToWrapper || e.target === el) {
        let touch = e;
        startX = touch.pageX;
        oldMinX = chart.minX;
        oldMaxX = chart.maxX;

        // drag = hover && e.type === CONST.E.start;

        document.body.addEventListener(
          CONST.E.move,
          onDrag,
          UTIL.passiveEventlistenerOpts()
        );

        document.body.addEventListener(
          CONST.E.end,
          onDragEnd,
          UTIL.passiveEventlistenerOpts()
        );
        onDrag(e);

        // onDragStart(e);

        // console.log('e', e);

        if (attachToWrapper) {
          // e.preventDefault && e.preventDefault();
          // e.stopPropagation && e.stopPropagation();
          // return false;
        }
      }
    }

    function onDrag(e: any) {
      // todo TouchEvent
      let touch = e;
      // throttle
      // console.log('e', e, handler, drag);
      if (e.type === CONST.E.move) {
        handler(
          e,
          touch.pageX - startX,
          {
            minX: oldMinX,
            maxX: oldMaxX
          },
          drag
        );
      }
    }

    function onDragEnd(e: any) {
      endHandler && endHandler(e, drag);
      document.body.removeEventListener(CONST.E.move, onDrag, false);
      document.body.removeEventListener(CONST.E.end, onDragEnd, false);
    }

    // TODO unclone
    if (attachToWrapper) {
      chart.wrapperEl.addEventListener(
        CONST.E.start,
        onDragStart,
        UTIL.passiveEventlistenerOpts()
      );
      chart.wrapperEl.addEventListener(
        CONST.E.start,
        onDragStart,
        UTIL.passiveEventlistenerOpts()
      );
    } else {
      el.addEventListener(
        CONST.E.start,
        onDragStart,
        UTIL.passiveEventlistenerOpts()
      );
      el.addEventListener(
        CONST.E.start,
        onDragStart,
        UTIL.passiveEventlistenerOpts()
      );
    }
  }
}
